import classNames from "classnames";
import { useEffect, useState } from "react";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import "./style.scss";
interface Props {
  className?: string;
  data: string;
}
export const CodeView = ({ className, data }: Props) => {
  const [numbers, setNumbers] = useState<{ number: string; error: boolean }[]>(
    [],
  );
  const [texts, setTexts] = useState<{ text: string; error: boolean }[]>([]);

  useEffect(() => {
    const tempLines = data.split(/\n/);
    setNumbers(
      tempLines
        .map((li) => ({
          number: li.split("|")[0].startsWith(">")
            ? li.split("|")[0].slice(1).trim()
            : li.split("|")[0].trim(),
          error: li.startsWith(">"),
        }))
        .filter((li) => li.number.length > 0),
    );
    setTexts(
      tempLines.map((li) => ({
        text:
          (li.split("|")[1] && li.split("|")[1].replace(/ /g, "\u00A0")) || "",
        error: li.startsWith(">"),
      })),
    );
    return () => {};
  }, [data]);
  return (
    <div className={classNames("code-view", className)}>
      <div className="code-view__number">
        {numbers.map((line, index) => (
          <div
            className={classNames("code-view__line", { error: line.error })}
            key={`${index}key`}
          >
            {line.error && (
              <BsFillArrowRightCircleFill color="#9d1e1b" size={16} />
            )}
            <div className="number">{line.number}</div>
          </div>
        ))}
      </div>
      <div className="code-view__main">
        {texts.slice(0, numbers.length).map((line, index) => (
          <div
            className={classNames("code-view__line", { error: line.error })}
            key={`${index}key`}
          >
            <div className="text">{line.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
